import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Header } from '../components/landing/Header';
import { Footer } from '../components/landing/Footer';

export default function SuccessPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <Header />
            <div className="pt-28 pb-20 px-6 lg:px-8">
                <div className="max-w-lg mx-auto text-center">
                    <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center mx-auto mb-6">
                        <Check className="w-8 h-8 text-emerald-500" />
                    </div>
                    <h1 className="text-3xl font-bold text-stone-900 mb-4">
                        Request Sent
                    </h1>
                    <p className="text-stone-500 leading-relaxed mb-8">
                        We have received your email. You will be contacted shortly to
                        discuss your needs further.
                    </p>

                    <Link to="/">
                        <Button
                            variant="outline"
                            className="border-stone-300 text-stone-700"
                        >
                            <ArrowLeft className="mr-2 w-4 h-4" />
                            Back to Home
                        </Button>
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}
